'use client';

import { Skeleton } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

import { FeedbackTeaser } from '@/core/components/feedback/feedback-teaser';
import { useEntitlements } from '@/core/hooks/use-entitlements';

type FeedbackFeatureGateProps = {
  children: ReactNode;
};

/** Shows teaser when `feature.feedback` is locked; otherwise children. */
export function FeedbackFeatureGate({ children }: FeedbackFeatureGateProps) {
  const { isFeatureEnabled, isLoading } = useEntitlements();

  if (isLoading) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }

  if (!isFeatureEnabled('feature.feedback')) {
    return <FeedbackTeaser />;
  }

  return <>{children}</>;
}
